import React from "react";

export const DEFAULT_LOGO = "/logo-symbol-light.png";
export const GLOWS = {
  blue: { label: "Azul", swatch: "#3B82F6" },
  gold: { label: "Dorado", swatch: "#F5B83D" },
  white: { label: "Blanco", swatch: "#F8FAFC" },
};

// Fondo negro con el logo grande en 3D: un destello va revelando distintas partes del logo.
const LogoRevealBg = ({ logo, glow = "blue" }) => {
  const src = logo || DEFAULT_LOGO;
  const maskStyle = {
    WebkitMaskImage: `url("${src}")`,
    maskImage: `url("${src}")`,
  };
  return (
    <div className={`lr-root lr-${GLOWS[glow] ? glow : "blue"} absolute inset-0 overflow-hidden bg-black`} aria-hidden="true" data-testid="logo-reveal-bg">
      <div className="lr-glow absolute left-1/2 top-1/2 h-[70vmin] w-[70vmin] -translate-x-1/2 -translate-y-1/2 rounded-full" />
      <div className="lr-stage absolute inset-0 flex items-center justify-center">
        <div className="lr-logo relative w-[86vmin] max-w-none">
          <img src={src} alt="" className="lr-ghost block w-full" draggable={false} />
          <img src={src} alt="" className="lr-reveal absolute inset-0 block w-full" draggable={false} />
          <div className="lr-shine lr-masked absolute inset-0" style={maskStyle} />
        </div>
      </div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_35%,rgba(0,0,0,.75)_100%)]" />
    </div>
  );
};

export default LogoRevealBg;
